import { useEffect, useState } from "react";
import useIsLandscape from "../../../hooks/useIsLandscape"; // Hook personalizado para detectar orientación
import MobileLogBlock from "./MobileLogBlock"; // Menú para usuarios móviles (portrait)
import HorizontalMenu from "./HorizontalMenu"; // Menú horizontal (landscape)

// Props del menú móvil
interface MobileMenuProps {
  isOpen: boolean; // Indica si el menú deslizante está abierto
  onClose: () => void; // Función para cerrarlo
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose  }) => {
  // 🔹 Detecta si el dispositivo está en landscape
  const isLandscape = useIsLandscape();

  // 🔹 Estado para detectar pantallas pequeñas (<1024px)
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);
  // 🔹 Listener de cambio de tamaño de ventana
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024); // Actualiza estado según el ancho
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔹 Si estamos en landscape y pantalla pequeña, mostramos menú horizontal fijo
  if (isLandscape && isSmallScreen) {
    return (
      <div className="fixed top-14 left-0 right-0">
        <HorizontalMenu />
      </div>
    );
  }

  // 🔹 Si estamos en portrait, mostramos el menú deslizante lateral
  return (
    <div
      className={`
        fixed top-18 right-0 w-20 bg-zinc-700 rounded-l-lg border-l-4 border-b-2 border-blue-400 shadow-md shadow-black p-4 
        z-[50] 
        transition-all duration-300 ease-in-out
        ${isOpen ? "opacity-100 pointer-events-auto translate-x-0" : "opacity-0 pointer-events-none translate-x-10"}
        flex justify-center items-center
      `}
    >
     <MobileLogBlock onClose={onClose} />

    </div>
  );
};

export default MobileMenu;
